import { PermissionsContextEnum } from 'generated/resources/graphql'

import { Model } from 'modules/core/lib/mobx-rest'

interface IPermission {
  authorized: boolean
  category: string | null // FIXME: Make non nullable
  category_label: string | null // FIXME: Make non nullable
  context: PermissionsContextEnum
  context_less: boolean
  id: string
  permissions_group_id: number
  resource: string | null
  verb: string
  verb_label: string
  verb_description: string
}

class Permission extends Model<IPermission> {
  static urlRoot() {
    return '/permissions/permissions'
  }

  get verbLabel() {
    return this.attributes.verb_label
  }

  get category() {
    return this.attributes.category
  }

  get categoryLabel() {
    return this.attributes.category_label
  }
}

export default Permission
